import { useState } from 'react';

const faqs = [
  {
    q: 'Can PRODIFY handle large parts catalogs?',
    a: 'Absolutely. PRODIFY supports thousands of SKUs with full compatibility data, fitment notes, and supplier mapping. Our Professional plan includes 50,000 SKUs, and Enterprise has no limits. Bulk import via CSV or direct supplier feeds is supported.',
  },
  {
    q: 'Does it integrate with existing suppliers?',
    a: 'Yes. PRODIFY supports CSV imports and direct API integrations with major SA parts suppliers. You can map supplier price lists, automate purchase orders, and track deliveries from within the platform.',
  },
  {
    q: 'Can customers book services online?',
    a: 'Yes, PRODIFY includes a built-in customer-facing booking system. Customers can select services, choose a date/time, and receive automated confirmation and reminders via SMS or email.',
  },
  {
    q: 'How does warranty tracking work?',
    a: 'Each part fitted to a vehicle can have a warranty period attached. PRODIFY automatically tracks expiry dates and sends alerts to both staff and customers before warranties expire — preventing disputes and building trust.',
  },
  {
    q: 'Can I manage multiple branches or locations?',
    a: 'Yes. The Professional and Enterprise plans support multi-location management with real-time stock sync between branches. Transfer stock between locations, view consolidated reports, and manage separate POS terminals per branch.',
  },
  {
    q: 'Is there a mobile app for technicians?',
    a: 'Yes. The PRODIFY mobile app lets technicians view job cards, update job status, capture before/after images, access vehicle history, and scan barcodes — all from their phone on the shop floor.',
  },
  {
    q: 'Is PRODIFY VAT-compliant for South Africa?',
    a: '100%. PRODIFY handles South African VAT (15%) automatically on all invoices, purchase orders, and reports. It is designed to align with SARS requirements and generates VAT-ready reports for your accountant.',
  },
  {
    q: 'How long does setup take?',
    a: 'Most businesses are live within 48 hours. We provide guided onboarding, data migration support, and staff training. Enterprise clients get dedicated implementation support and on-site training.',
  },
];

const FAQ = () => {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="bg-[#0a1628] py-24 px-6" id="faq">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/5 border border-white/10 rounded-full mb-5">
            <i className="ri-question-answer-line text-[#f97316] text-sm"></i>
            <span className="text-gray-300 text-xs font-semibold tracking-widest uppercase">Got Questions?</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white" style={{ fontFamily: "'Poppins', sans-serif" }}>
            Frequently Asked Questions
          </h2>
          <p className="text-gray-400 text-base mt-4 max-w-xl mx-auto">
            Everything you need to know about PRODIFY. Can&apos;t find your answer? Chat with our team.
          </p>
        </div>

        {/* Accordion */}
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`rounded-xl border overflow-hidden transition-all duration-300 ${
                open === i
                  ? 'border-[#3b82f6]/40 bg-[#0f2040]'
                  : 'border-white/10 bg-[#0a1628] hover:border-white/20'
              }`}
            >
              <button
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
                onClick={() => setOpen(open === i ? null : i)}
              >
                <span className="text-white font-semibold text-sm pr-4" style={{ fontFamily: "'Poppins', sans-serif" }}>
                  {faq.q}
                </span>
                <div className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 ${open === i ? 'bg-[#3b82f6] rotate-45' : 'bg-white/10'}`}>
                  <i className="ri-add-line text-white text-sm"></i>
                </div>
              </button>
              {open === i && (
                <div className="px-6 pb-5">
                  <p className="text-gray-300 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <p className="text-gray-400 text-sm">
            Still have questions?{' '}
            <a href="#demo" className="text-[#f97316] hover:underline cursor-pointer">Chat with our team →</a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
